export const mediaFilterType = Object.freeze({
  ALL: 'all',
  MY_MEDIA: 'myMedia',
});
